import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fc434e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "form-control form-control-solid"
}
const _hoisted_2 = { for: "" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "mt-1 mb-0"
}
const _hoisted_5 = {
  key: 1,
  class: "mb-0 mt-1"
}
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!

  return (_ctx.isReadOnly)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.value), 1)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_component_date_picker, _mergeProps(_ctx.attributes, {
          modelValue: _ctx.internalDate,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalDate) = $event)),
          format: _ctx.setFormattedValue,
          onCleared: _ctx.handleCleared,
          "auto-apply": ""
        }), null, 16, ["modelValue", "format", "onCleared"]),
        (_ctx.validationState.$errors.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validationState.$errors, (error) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: error.$uid,
                  class: "text-danger fw-bold mb-0"
                }, _toDisplayString(error.$message), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.serverErrors.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serverErrors, (error, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: `${_ctx.attributes.name}-error-${index}`,
                  class: "text-danger fw-bold mb-0"
                }, [
                  _createElementVNode("div", {
                    innerHTML: _ctx.$sanitize(error)
                  }, null, 8, _hoisted_6)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
}